"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Feedback/RatingMeter/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _MeterItem = require('./MeterItem'); var _MeterItem2 = _interopRequireDefault(_MeterItem);










const RatingMeter = ({
  className, itemClassName, currentRating, onRatingUpdate, onRatingSubmit, isSubmitted,
}) => {
  const rootClassName = _classBuilder2.default.call(void 0, className,
    "meeting--feedback--meter-wrapper")
  const pointClassName = _classBuilder2.default.call(void 0, itemClassName,
    "meeting--feedback--meter--item")

  return (
    _react2.default.createElement('div', { className: rootClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
      , 
        Array(5).fill(null).map((_, i) => (
          _react2.default.createElement(_MeterItem2.default, {
            key: i,
            idx: i,
            className: pointClassName,
            onRatingUpdate: onRatingUpdate,
            onRatingSubmit: onRatingSubmit,
            isActive: i < currentRating,
            isSubmitted: isSubmitted, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
          )
        ))
      
    )
  )
}

exports. default = RatingMeter
